
import api from '../../api/index.js'

const state = {

}

const getters = {
}

const actions = {
    WebHome({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/AppHome/WebHome',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
